export interface ISingleUserType {
  value: keyof IKeyedUserTypes
  name: string
}

export enum USER_TYPE {
  carrier = 'carrier',
  shipper = 'shipper',
  admin = 'admin',
  system = 'system',
}

export interface IUserTypes extends Record<USER_TYPE, ISingleUserType[]> {}

export interface IKeyedUserTypes {
  dispatcher: ISingleUserType
  // eslint-disable-next-line camelcase
  owner_operator: ISingleUserType
  driver: ISingleUserType
  shipper: ISingleUserType
  // eslint-disable-next-line camelcase
  sales_rep: ISingleUserType
  admin: ISingleUserType
  bot: ISingleUserType
}

export interface IUserGroupBooleans {
  isAdmin: boolean
  isDriver: boolean
  isOwnerOperator: boolean
  isDispatcher: boolean
  isShipper: boolean
  isSalesRep: boolean
}

export const userTypes: IUserTypes = {
  carrier: [
    { value: 'dispatcher', name: 'Dispatcher' },
    { value: 'owner_operator', name: 'Owner Operator' },
    { value: 'driver', name: 'Driver' },
  ],
  shipper: [
    { value: 'shipper', name: 'Shipper' },
    { value: 'sales_rep', name: 'Sales Rep' },
  ],
  admin: [
    { value: 'admin', name: 'Admin' },
    { value: 'bot', name: 'Bot' },
  ],
  system: [],
}

export const userTypesList = [
  ...userTypes.shipper.map(entry => ({ ...entry, type: 'shipper' })),
  ...userTypes.carrier.map(entry => ({ ...entry, type: 'carrier' })),
  ...userTypes.admin
    .filter(entry => entry.value !== 'bot')
    .map(entry => ({ ...entry, type: 'other' })),
]

export const roles = [
  { value: 'employee', name: 'Employee' },
  { value: 'admin', name: 'Admin' },
]
